import React from "react";
import { Label } from "semantic-ui-react";

const EventHeaderStatusLabel = ({ status, ...props }) => (
  <Label {...props} basic icon="list" size="large" content={status} />
);

export default EventHeaderStatusLabel;
